import { useContext } from "react"
import { IsSsrMobileContext } from "../context/isMobileContext"

// -------------------------------------------|| IS MOBILE - HOOKS ||------------------------------------------------------

export const useIsMobile = () => {
  return useContext(IsSsrMobileContext)
}
